// extracted by mini-css-extract-plugin
export default {"container":"Carousel_container__EdKl+","slide":"Carousel_slide__HP2lq","btn":"Carousel_btn__12QKP","prev":"Carousel_prev__S1bFH","next":"Carousel_next__HfAI9"};